import React from "react";
import {ButtonGroup, Col, Container, Row, Spinner, Table} from "react-bootstrap";
import {Image as ImageIcon, Table as TableIcon} from "react-bootstrap-icons";
import {DismissibleAlert} from "../Alerts/DismissibleAlert";
import {SYNERGY_FINDER_BUCKET_NAME, SynergyFinderPipelineStatus} from "./Const"
import {DownloadButton} from "../CommonUIComponent/DownloadButton";
import {Pipeline} from "./TanStackSynergyFinderHistoryTable";
import { StorageImage } from '@aws-amplify/ui-react-storage';
import { ConsoleLogger } from 'aws-amplify/utils';
import notFoundImage from "../../404_not_found_image.png";

const logger = new ConsoleLogger("SynergyFinderReport.tsx");

interface SynergyFinderReportProps {
    selectedReports: Pipeline[]
    refreshHistoryTable(): void
}

interface SynergyFinderReportState {}

export class SynergyFinderReport extends React.Component<SynergyFinderReportProps, SynergyFinderReportState> {
    constructor(props: SynergyFinderReportProps) {
        super(props);
        this.state = {}
    }

    render() {
        if (this.props.selectedReports.length === 0) {
            return (<></>)
        }

        return <>
            {this.props.selectedReports.map((selectedReport, i) => {
                let reportRendering = <>
                    <Row>
                        <Col md={12}>
                            <Table bordered striped>
                                <thead>
                                <tr>
                                    <th>Description</th>
                                    <th>Gene status</th>
                                    <th>Drug 1</th>
                                    <th>Drug 2</th>
                                    <th>Cell line</th>
                                    <th>Calculation method</th>
                                    <th>Download</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>{selectedReport.description}</td>
                                    <td>{selectedReport.geneStatus}</td>
                                    <td>{selectedReport.drug1}</td>
                                    <td>{selectedReport.drug2}</td>
                                    <td>{selectedReport.cellLine}</td>
                                    <td>{selectedReport.calculationMethod}</td>
                                    <td>
                                        <ButtonGroup>
                                            <DownloadButton className={"me-1"} s3Bucket={SYNERGY_FINDER_BUCKET_NAME} s3Keys={[selectedReport.s3KeyOutputExcel]} variant={"primary"} icon={<TableIcon />} />
                                            <DownloadButton s3Bucket={SYNERGY_FINDER_BUCKET_NAME} s3Keys={[selectedReport.s3KeyOutputGraphImage]} variant={"primary"} icon={<ImageIcon />} />
                                        </ButtonGroup>
                                    </td>
                                </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <StorageImage
                                style={{display: "flex", justifyContent: "center", maxHeight: "20rem"}} 
                                path={selectedReport.s3KeyOutputGraphImageSmall} 
                                alt={selectedReport.s3KeyOutputGraphImageSmall} 
                                bucket={SYNERGY_FINDER_BUCKET_NAME} 
                                onGetUrlError={(e: Error) => {logger.error("get url error: ", e)}}
                                fallbackSrc={notFoundImage}
                                loadingElement={<>
                                    <Spinner
                                        animation="border"
                                        size="sm"
                                        variant="primary"
                                    >
                                    </Spinner>
                                    <span className="text-primary m-2 fw-bold">Downloading graph ...</span>
                                </>}
                            />
                        </Col>
                    </Row>
                </>
                if (selectedReport.calculationStatus === SynergyFinderPipelineStatus.IN_PROGRESS) {
                    reportRendering = <>
                        <h6 style={{marginBottom: 20}}>{selectedReport.description}</h6>
                        <Spinner
                            animation="border"
                            size="sm"
                            variant="primary"
                        >
                        </Spinner>
                        <span className="text-primary m-2 fw-bold">Calculating synergy, may take few minutes ...</span>
                    </>
                } else if (selectedReport.calculationStatus === SynergyFinderPipelineStatus.FAILED) {
                    reportRendering = <>
                        <h6 style={{marginBottom: 20}}>{selectedReport.description}</h6>
                        <DismissibleAlert message={selectedReport.errorMessage}/>
                    </>
                }
                      
                return <div key={selectedReport.uuid}>
                    <hr/>
                    <Container className="p-4 bg-light wide-container">
                        {reportRendering}
                    </Container>
                </div>
            })}
        </>
    }
}